export { ContractActionArea } from './index.pc'
export { MobileContractActionArea } from './index.mobile'
